import React from "react";
import { ensure } from "sprint-common-web";

import { RecordType } from "../../../../../common/types/RecordType";
import { CloudFileQcDoneDialog } from "../../../common/components/qc-done/CloudFileQcDoneDialog";
import { useQcDoneValidation } from "./useQcDoneValidation";

interface QcDoneStatusDialogProps {
    isOpen: boolean;
    onClose: () => void;
    cloudFileId?: string;
    cloudFileRecordType?: RecordType;
    fileRecordId?: string;
    onHandleConfirmation?: () => void;
}

export const QcDoneStatusDialog: React.VFC<QcDoneStatusDialogProps> = ({
    isOpen,
    onClose,
    cloudFileId,
    fileRecordId,
    cloudFileRecordType,
    onHandleConfirmation
}: QcDoneStatusDialogProps) => {
    const { validate } = useQcDoneValidation();

    ensure(cloudFileId);
    ensure(cloudFileRecordType);

    return (
        <CloudFileQcDoneDialog
            cloudFileId={cloudFileId}
            cloudFileRecordType={cloudFileRecordType}
            fileRecordId={fileRecordId}
            onHandleConfirmation={onHandleConfirmation}
            isOpen={isOpen}
            onClose={onClose}
            validate={validate}
            width={1200}
        />
    );
};
